<template>
    <div>
        <el-row class="banner" type="flex" justify="center" align="middle">
            <el-col :span="12">
                <el-col style="margin-bottom: 2em; color: white; font-size: 18px" align="center">
                    SIPAC27<br>
                    <small>{{version}}</small>
                </el-col>
                <el-col>
                    <el-form
                        size="small"
                        @submit.native.prevent
                        ref="credentials"
                        :model="credentials"
                        status-icon>
                        <el-row type="flex" justify="center">
                            <el-col :span="12">
                                <el-form-item
                                    prop="username"
                                    :rules="{
                                        required: true,
                                        message: 'Escriba su nombre de usuario',
                                        trigger: 'change'
                                    }">
                                    <el-input
                                        :disabled="requestAccessLoading"
                                        placeholder="Usuario"
                                        v-model="credentials.username">
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                    prop="password"
                                    :rules="{
                                        required: true,
                                        message: 'Escriba su contraseña',
                                        trigger: 'change'
                                    }">
                                    <el-input
                                        :disabled="requestAccessLoading"
                                        placeholder="Contraseña"
                                        v-model="credentials.password"
                                        show-password
                                        @keyup.enter.native="requestAccess">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="center">
                            <el-col :span="12" align="center">
                                <el-form-item>
                                    <el-button type="primary"
                                               @click="requestAccess"
                                               :loading="requestAccessLoading">
                                        {{ !requestAccessLoading ? 'Ingresar' : 'Ingresando'}}
                                    </el-button>
                                </el-form-item>
                                <el-button type="text" @click="openModal()" class="count-character"
                                           v-if="preRegisterShow">
                                    Solicitar registro
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
                <el-col style="margin-bottom: 5em; color: white; font-size: 12px" align="center">
                    <img src="/img/login/logo_sre.png" style="margin: 5% 30%;" width="20%">
                    <p>&copy; {{ currentYear }} - Secretaría de Relaciones Exteriores</p>
                </el-col>

            </el-col>
        </el-row>

        <el-dialog title="Solicitud Alta de Usuario"
                   :visible.sync="showRegister"
                   fullscreen
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-collapse accordion v-model="activeName">
                        <el-collapse-item name="1" title="Información General">
                            <div>
                                <el-form ref="user-form" :model="userForm" label-width="120px" label-position="top">
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item
                                                label="Tipo de usuario"
                                                prop="isLdap"
                                                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                                                <el-switch
                                                    :disabled="true"
                                                    v-model="userForm.isLdap"
                                                    active-text="Interno"
                                                    inactive-color="#13322B"
                                                    active-color="#9d2438"
                                                    inactive-text="Externo">
                                                </el-switch>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item
                                                label="Usuario"
                                                prop="username"
                                                :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'change' },
                                        { pattern:/^[ña-z-ú_]+?$/, message: 'Ingrese sólo letras minúsculas' }]">
                                                <el-input v-my-only-letters="{maxChars: 20}"
                                                          v-model="userForm.username"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item
                                                label="Correo electrónico"
                                                prop="email"
                                                :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                { type: 'email', message: 'Introduzca un correo valido', trigger: 'blur' },
                                { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' }]">
                                                <el-input v-my-only-alphanumeric="{maxChars: 70}"
                                                          :disabled="userForm.isLdap"
                                                          v-model="userForm.email"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item
                                                label="Apellido Paterno"
                                                prop="firstName"
                                                :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                                                <el-input :disabled="userForm.isLdap" v-model="userForm.firstName"
                                                          v-my-only-alphanumeric="{maxChars: 70}"
                                                          class="input-with-select">
                                                    <el-select class="el-select-custom"
                                                               v-model="userForm.cat_user_prefix_id" slot="prepend"
                                                               placeholder="tít.">
                                                        <el-option
                                                            v-for="prefix in prefixes"
                                                            :key="prefix.id"
                                                            :label="prefix.name"
                                                            :value="prefix.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="Apellido Materno"
                                                          :rules="{pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}">
                                                <el-input :disabled="userForm.isLdap"
                                                          v-my-only-alphanumeric="{maxChars: 70}"
                                                          v-model="userForm.secondName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item
                                                label="Nombre(s)"
                                                prop="name"
                                                :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                                                <el-input :disabled="userForm.isLdap"
                                                          v-my-only-alphanumeric="{maxChars: 70}"
                                                          v-model="userForm.name"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item
                                                label="Oficina"
                                                prop="cat_office_id"
                                                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                                                <el-select
                                                    v-model="userForm.cat_office_id"
                                                    filterable
                                                    clearable
                                                    placeholder="Seleccionar"
                                                    style="width: 100% !important;">
                                                    <el-option
                                                        v-for="office in offices"
                                                        :key="office.id"
                                                        :label="office.name"
                                                        :value="office.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item
                                                label="Perfil"
                                                prop="cat_profile_id"
                                                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                                                <el-select
                                                    @change="setRequirements(userForm.cat_profile_id)"
                                                    v-model="userForm.cat_profile_id"
                                                    filterable
                                                    placeholder="Seleccionar"
                                                    style="width: 100%">
                                                    <el-option
                                                        v-for="profile in profiles"
                                                        :key="profile.id"
                                                        :label="profile.name"
                                                        :value="profile.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item
                                                label="Usuario Extranjero"
                                                prop="isLdap"
                                                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                                                <el-switch
                                                    @change="filterRequirements(userForm.isForeign)"
                                                    v-model="userForm.isForeign"
                                                    active-text="Extranjero"
                                                    inactive-color="#13322B"
                                                    active-color="#9d2438"
                                                    inactive-text="Nacional">
                                                </el-switch>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="24" v-if="userForm.cat_profile_id == 5">
                                            <el-form-item label="Banco"
                                                          prop="cat_bank_id"
                                                          :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                                                <el-select
                                                    v-model="userForm.cat_bank_id"
                                                    filterable
                                                    placeholder="Seleccionar"
                                                    style="width: 100%">
                                                    <el-option
                                                        v-for="bank in banks"
                                                        :key="bank.id"
                                                        :label="bank.name"
                                                        :value="bank.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>

                                        </el-col>
                                        <el-col :span="24" v-if="userForm.cat_profile_id == 6">
                                            <el-form-item label="No. de Corredor Público"
                                                          prop="publicHallNumber"
                                                          :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                                                <el-input v-model="userForm.publicHallNumber"/>
                                            </el-form-item>

                                        </el-col>
                                        <el-col :span="24" v-if="userForm.cat_profile_id == 7">
                                            <el-form-item label="Notaria"
                                                          prop="cat_notary_id"
                                                          :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                                                <el-select
                                                    v-model="userForm.cat_notary_id"
                                                    filterable
                                                    placeholder="Seleccionar"
                                                    style="width: 100%">
                                                    <el-option
                                                        v-for="notary in notaries"
                                                        :key="notary.id"
                                                        :label="notary.name && notary.state && notary.state.name ?
                                                        notary.name +' '+notary.state.name : notary.name"
                                                        :value="notary.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20" v-if="!userForm.isLdap">
                                        <el-col :span="12">
                                            <el-form-item
                                                label="Contraseña"
                                                prop="password"
                                                :rules="[
                        {
                          required: true,
                          message: 'Escriba una contraseña', trigger: 'change'
                        },
                        {
                          min: 12,
                          message: 'Escriba al menos 12 caracteres', trigger: 'change'
                        },
                        {
                          pattern: '.*[0-9].*',
                          message: 'Indique al menos un número', trigger: 'change'
                        },
                        {
                          pattern: '.*[a-z]',
                          message: 'Indique al menos una minuscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[A-Z]',
                          message: 'Indique al menos una mayúscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[¡!@#$%^&*(),.¿?:{}|<>]',
                          message: 'Indique al menos un carácter especial', trigger: 'change'
                        }
                      ]">
                                                <template>
                                                    <password style="background-color: #ffffff !important;"
                                                              :toggle="true"
                                                              :badge="false"
                                                              v-model="userForm.password"/>
                                                </template>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item
                                                label="Repetir contraseña"
                                                prop="passwordConfirm"
                                                :rules="[
                        {
                          required: true,
                          message: 'Escriba una contraseña', trigger: 'change'
                        },
                        {
                          min: 12,
                          message: 'Escriba al menos 12 caracteres', trigger: 'change'
                        },
                        {
                          pattern: '.*[0-9].*',
                          message: 'Indique al menos un número', trigger: 'change'
                        },
                        {
                          pattern: '.*[a-z]',
                          message: 'Indique al menos una minuscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[A-Z]',
                          message: 'Indique al menos una mayúscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[¡!@#$%^&*(),.¿?:{}|<>]',
                          message: 'Indique al menos un carácter especial', trigger: 'change'
                        }
                      ]">
                                                <el-input
                                                    v-model="userForm.passwordConfirm"
                                                    show-password
                                                    @change="checkPassword(userForm.password, userForm.passwordConfirm)"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <br>
                                </el-form>
                            </div>

                        </el-collapse-item>
                        <el-collapse-item title="Documentación" name="2" v-if="userForm.cat_profile_id">
                            <el-alert
                                title="Documentos requeridos:"
                                type="info"
                                show-icon>
                                 <span>
                                    <div style="font-size: 8pt !important;"
                                         v-for="(item, key) in auxRequeriments">
                                         <i v-if="!item.isActive" class="fas fa-check"></i>   {{item.name}}
                                    </div>
                                 </span>
                            </el-alert>
                            <div>
                                <Docs :requirements="auxRequeriments" :type="3">
                                    <div slot="main">
                                        Adjunte toda la documentación requerida, indicado en la descripción el tipo de
                                        documento agregado.
                                    </div>
                                </Docs>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
                <el-col :span="24" align="end">
                    <el-button
                        type="danger"
                        icon="fas fa-times"
                        @click="resetForm()">
                        Cancelar
                    </el-button>
                    <el-button
                        type="primary"
                        icon="fas fa-save"
                        @click="singUp()">
                        Solicitar
                    </el-button>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import password from 'vue-password-strength-meter'
    import Docs from '@/components/partials/Docs';

    export default {
        components: {
            password,
            Docs
        },
        data() {
            return {
                activeName: ['1'],
                showRegister: false,
                offices: [],
                profiles: [],
                banks: [],
                notaries: [],
                prefixes: [],
                auxRequeriments: [],
                credentials: {

                    username: '',
                    password: ''
                    //token: this.$route.query.token,
                },
                requestAccessLoading: false,
                userForm: {
                    isLdap: false,
                    isActive: true,
                },
                preRegisterShow: false,
                version: '',

            }
        },
        computed: {
            currentYear() {
                return new Date().getFullYear();
            },
            ...mapGetters('utils', {
                userRequest: "userRequest",
            }),
        },

        watch: {
            'userForm.cat_profile_id'(value) {
                this.auxRequeriments = this.userRequest.requirements
            }
        },


        created() {
            this.version = window.versionApp;
            this.userRequest.requirements = [];
            this.userRequest.try = 0;
            axios.get('/api/sing-up-catalogs').then(response => {
                if (response.data.success) {
                    this.profiles = response.data.profiles;
                    this.offices = response.data.offices;
                    this.prefixes = response.data.prefixes;
                    this.banks = response.data.banks;
                    this.notaries = response.data.notaries;
                    this.preRegisterShow = response.data.preRegisterShow
                } else {
                    this.$message({
                        type: 'error',
                        message: response.data.message
                    });
                }
            })
        },
        methods: {
            ...mapActions('utils', [
                'modifyRequest'
            ]),

            clearRequest() {
                this.showRegister = false;
                this.userForm = {};
                this.userForm.isActive = false;
                this.userForm.isLdap = false;
            },

            checkPassword(pass, confirmPass) {

                if (pass !== confirmPass) {
                    this.$notify({
                        type: 'warning',
                        title: 'Contraseña',
                        message: 'La contraseña no coincide, intente de nuevo.'
                    });
                }
            },
            singUp() {
                this.userForm.documents = this.userRequest.documents;

                let _check = this.userForm.documents.filter(up => up.cat_requirement_document_id == null || up.cat_requirement_document_id == '');

                if (_check && _check.length > 0 || this.userRequest.documents.length != this.auxRequeriments.length) {
                    this.$notify({
                        type: 'warning',
                        title: 'Atención',
                        message: 'Debe adjuntar todos los documentos requeridos e indicar la correspondencia para todos los archivos adjuntados.'
                    });
                    return false;
                }

                this.$refs['user-form'].validate((valid) => {
                    if (valid && this.userForm.documents && this.userForm.documents.length > 0) {
                        let _valid = null;
                        _.forEach(this.userForm.documents, (item, key) => {
                            if (item.description && !item.description.match(/^[ña-zÀ-úÑA-Z0-9 _]+$/)) {
                                _valid = false;
                            } else {
                                _valid = true;
                            }
                        });
                        if (_valid) {
                            this.$store.dispatch(
                                'loading/spinner',
                                {msg: 'Cargando Datos...', status: true},
                                {root: true}
                            );
                            let _data = {
                                ...this.userForm
                            };
                            axios.post('/api/sing-up', _data).then(response => {
                                if (response.data.success) {
                                    this.$message({
                                        type: 'success',
                                        message: response.data.message
                                    });
                                    this.clearRequest();
                                    setTimeout(() => {
                                        location.reload();
                                    }, 1500)
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: response.data.message
                                    });
                                }

                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: 'Corrija los formatos'
                            });
                        }

                    } else {
                        this.$message({
                            type: 'error',
                            message: 'Complete los campos requeridos y agregue al menos un documento'
                        });
                    }

                });


            },
            requestAccess() {
                this.requestAccessLoading = true;

                if (this.credentials.username.length === 0 || this.credentials.password.length === 0) {
                    this.requestAccessLoading = false;

                    this.$message({
                        type: 'warning',
                        message: 'El campo de usuario y contraseña son obligatorios.'
                    });

                    return false;
                }


                setTimeout(() => {
                    axios.post('/login', this.credentials).then(response => {
                        this.requestAccessLoading = false;

                        if (response.data.authenticated === true) {
                            window.sessionStorage.setItem('sipac_token', response.data.sipac_token);
                            window.sessionStorage.setItem('sipac_token_expiration', response.data.sipac_token_expiration);
                            window.sessionStorage.setItem('sipac_user', response.data.sipac_user);
                            window.sessionStorage.setItem('user', JSON.stringify(response.data.user));

                            //splash
                            window.localStorage.removeItem('sipac_splash');

                            if (window.sessionStorage.getItem('sipac_token')) {
                                window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('sipac_token');
                            }

                            this.$store.commit('setUser', response.data.user);
                            if (response.data.user.cat_profile_id >= 4) {
                                window.location.replace("/solicitudes");
                            } else {
                                this.$router.push('/');
                            }

                        } else {
                            this.requestAccessLoading = false;
                            let _params = {};
                            if (response.data.sessions && response.data.sessions > 0) {

                                this.$prompt('Usted ya tiene una sesión abierta. Ingrese su contraseña para continuar', 'Alerta', {
                                    confirmButtonText: 'Ingresar',
                                    cancelButtonText: 'Cancelar',
                                    inputValidator: this.validatePassowrd,
                                    inputType: 'password',
                                    inputErrorMessage: 'Ingrese al menos 7 caracteres'
                                }).then(({value}) => {
                                    if (value) {
                                        this.credentials.manySessions = true;
                                        this.credentials.password = value;
                                        this.requestAccess()
                                    } else {
                                        this.$store.dispatch('notifications/warning', {msg: 'Debe ingresar su contraseña para poder continuar'}, {root: true});
                                    }
                                }).catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: 'Inicio de sesión cancelado por el usuario.'
                                    });
                                });
                            }
                            this.userRequest.try = this.userRequest.try + 1;
                            this.$message({
                                type: 'warning',
                                message: response.data.message
                            });
                        }

                    }).catch(err => {
                        this.requestAccessLoading = false;
                        this.userRequest.try = this.userRequest.try + 1;
                        this.$message({
                            type: 'warning',
                            message: 'Usuario o contraseña incorrecta, inténtelo nuevamente.'
                        });
                    });
                }, 2500);
            },
            openModal() {
                this.showRegister = true;
                this.userRequest.id = null;
                this.userRequest.documents = [];


            },

            setRequirements(profile) {
                if (profile) {
                    this.userRequest.requirements = [];
                    this.userRequest.isPreregister = true;

                    this.userRequest.requirements = this.profiles.filter(up => up.id == profile);
                    this.userRequest.requirements = this.userRequest.requirements[0].documents;
                    this.userForm.isForeign = true;

                }

            },
            filterRequirements(value) {
                let _array = [];
                if (value == true) {
                    _array = this.userRequest.requirements.filter(function (up) {
                        up.isActive = true
                        return up.isForeign && up.isActive || !up.isForeign
                    })
                } else if (value == false) {

                    _array = this.userRequest.requirements.filter(function (up) {
                        up.isActive = true
                        return up.isActive && !up.isForeign
                    })

                }
                this.auxRequeriments = _array

            },

            resetForm() {
                this.showRegister = false;
                location.reload();
            },

            validatePassowrd(pass) {
                if (pass && pass.length < 7) {
                    return 'Ingrese al menos 7 caracteres.'
                } else return true;
            },
        }
    }
</script>

<style>

    * {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    body {
        padding: 0 !important;
        margin: 0 !important;
    }

    .count-character {
        font-size: 10px;
        text-align: center;
        color: #ffffff;
    }

    #notfound {
        position: relative;
        height: 100vh;
    }

    #notfound .notfound {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .notfound {
        max-width: 520px;
        width: 100%;
        line-height: 1.4;
        text-align: center;
    }

    .notfound .notfound-404 {
        position: relative;
        height: 200px;
        margin: 0px auto 20px;
        z-index: -1;
    }

    .notfound .notfound-404 h1 {
        font-family: 'Montserrat', sans-serif;
        font-size: 236px;
        font-weight: 200;
        margin: 0px;
        color: #211b19;
        text-transform: uppercase;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .notfound .notfound-404 h2 {
        font-family: 'Montserrat', sans-serif;
        font-size: 28px;
        font-weight: 400;
        text-transform: uppercase;
        color: #211b19;
        background: #fff;
        padding: 10px 5px;
        margin: auto;
        display: inline-block;
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
    }

    .notfound a {
        font-family: 'Montserrat', sans-serif;
        display: inline-block;
        font-weight: 700;
        text-decoration: none;
        color: #fff;
        text-transform: uppercase;
        padding: 13px 23px;
        background: #ff6300;
        font-size: 18px;
        -webkit-transition: 0.2s all;
        transition: 0.2s all;
    }

    .notfound a:hover {
        color: #ff6300;
        background: #211b19;
    }

    @media only screen and (max-width: 767px) {
        .notfound .notfound-404 h1 {
            font-size: 148px;
        }
    }

    @media only screen and (max-width: 480px) {
        .notfound .notfound-404 {
            height: 148px;
            margin: 0px auto 10px;
        }

        .notfound .notfound-404 h1 {
            font-size: 86px;
        }

        .notfound .notfound-404 h2 {
            font-size: 16px;
        }

        .notfound a {
            padding: 7px 15px;
            font-size: 14px;
        }
    }

    .banner {
        background-image: url('/img/login/home.png');
        background-repeat: no-repeat;
        background-size: cover;
        height: 100vh;
        width: 100vw;
    }

</style>

